import { APP } from 'src/app/config/app';
import { ScheduleViewMode } from 'src/app/models/enums';

function spanRange(mode: ScheduleViewMode, visibleMinutesPerDay: number, visibleDaysPerWeek: number): { max: number; min: number } {
  return mode === ScheduleViewMode.DAY
    ? { max: visibleMinutesPerDay, min: Math.min(APP.MINUTES_PER_HOUR, visibleMinutesPerDay) }
    : { max: visibleDaysPerWeek * visibleMinutesPerDay, min: visibleMinutesPerDay };
}

// Exponential interpolation so every slider step feels like the same zoom ratio
export function visibleSpanMinutes(
  mode: ScheduleViewMode,
  zoom: number,
  visibleMinutesPerDay = APP.MINUTES_PER_DAY,
  visibleDaysPerWeek = APP.SCHEDULE_ALL_WEEKDAYS.length,
): number {
  const { max, min } = spanRange(mode, visibleMinutesPerDay, visibleDaysPerWeek);
  return max * Math.pow(min / max, Math.min(Math.max(zoom, 0), 1));
}

export function visibleSpanLabel(
  mode: ScheduleViewMode,
  zoom: number,
  visibleMinutesPerDay = APP.MINUTES_PER_DAY,
  visibleDaysPerWeek = APP.SCHEDULE_ALL_WEEKDAYS.length,
): string {
  const span = visibleSpanMinutes(mode, zoom, visibleMinutesPerDay, visibleDaysPerWeek);
  const days = span / visibleMinutesPerDay;
  return days < 1 ? `${Math.round(span / APP.MINUTES_PER_HOUR)}h` : `${Math.round(days)}d`;
}
